<template>
  <section class="noti">

    <article class="media" style="width:500px;">
      <figure class="media-left" >
        <p class="image is-64x64">
          <img :src=user_avatar >
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p>
            <strong class="is-clickable" @click="$router.push(`/users/${username}`)">{{ user }}</strong> left a comment !<br>

            <small>
              <time datetime="2018-07-07">
                {{ dateFromNow(comment_date) }}
              </time></small>
            <br>

          </p>
        </div>

      </div>
      <div class="media-right">
        <button class="delete"></button>
      </div>
    </article>
  </section>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin.js'
export default {
  mixins: [dateMixin],
  props: ['content'],
  computed: {
    comment () {
      return this.content.attributes.notifiable.data
    },
    user () {
      return this.comment.attributes.cosplayer_name
    },
    username () {
      return this.comment.attributes.username
    },
    user_avatar () {
      return this.comment.attributes.avatar.url
    },
    comment_date () {
      return this.comment.attributes.created_at
    }
  }
}
</script>
